 <!-- 我的报名 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的报名</p>
      </div>
    </div>
    <!-- <div class="nav-list">
      <ul>
        <li class="type" :class="type==0?'cur':''" @click="onCur(0)">全部</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">报名中</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">已报名</li>
      </ul>
    </div> -->
    <div class="enroll-list">
      <ul>
        <li v-for="item,index in examItem" :key="index"   >
          <div class="img">
            <img :src="item.examImg">
          </div>
          <div class="contetn">
            <div class="contetn-top" style="padding-top: 0;">
              <p class="title">{{item.examName}}</p>
              <p class="type" v-if="item.signStatus==0">报名中</p>
              <p class="type" v-else-if="item.signStatus==1">已报名</p>
              <!-- <p class="type" v-else-if="item.signStatus==2">已取消</p> -->
              <!-- <p class="type types" v-else-if="item.signStatus==3">已结束</p> -->
            </div>
            <div class="contetn-top" style="justify-content: flex-start;border: none">
              <p class="type" style="width: 40px;">线上</p>
              <p class="time">考试时间:{{item.startTime}}</p>
            </div>
            <div style="display: flex;align-items: center;justify-content: flex-start;">
              <el-popconfirm
                title="确定取消当前报名吗？"
                @confirm="signCancel(item.id)"
                v-if="item.signStatus!=3"
              >
                <el-button slot="reference" size="small" type="warning" style="margin-right: 10px;background-color: #ff821c" v-if="item.status==0">取消报名</el-button>
              </el-popconfirm>
              <el-button class="buttons" size="small" @click="onExamDetails(item.examId)">了解详情</el-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="rows"
        @current-change="currentChange">
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import { mySignRecord,signCancel } from '../../api/userMG'
export default {
  data() {
    return {
      type:0,
      examItem:[],
      page:1,
      rows:10,
      total:0,
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.getMySignRecord()
  },
  methods:{
    currentChange(e){
      console.log(e)
      this.page = e;
      this.getMySignRecord()
    },
    onCur(e){
      this.type = e;
      this.getMySignRecord()
    },
    // 我的报名列表
    getMySignRecord(){
      let params = {
        page:this.page,
        rows:this.rows,
        signStatus:1
        // signStatus:this.type==0?'':this.type-1
      }
      mySignRecord(params).then(res => {
        console.log('报名数据',res);
        this.total = res.data.total;
        this.examItem = res.data.content;
      })
    },
    signCancel(id){
      let params = {
        signId:id
      }
      signCancel(params).then(res => {
        console.log('取消报名',res);
        if(res.code==0){
          this.$message({
            message: '取消成功',
            type: 'warning',
            offset:100
          })
          this.getMySignRecord();
        }
      })
      .catch(err => {
        // this.$message.error('菜单加载失败，请稍后再试！')
      })
    },
    onExamDetails(id){
      this.$router.push({path:'/index/examDetails', query: { id: id, type:2 }})
    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
    margin-bottom: 32px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 12px;
    /* margin:  0 10px; */
    cursor: pointer;
  }
  .divider{
    margin:  0 10px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  .enroll-list{
    margin: 30px 0 50px;
  }
  .enroll-list ul li{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .enroll-list ul li .img{
    margin-right: 18px;
    width: 270px;
  }
  .enroll-list ul li .img img{
    width: 270px;
    height: 155px;
    border-radius: 4px;
  }
  .enroll-list ul li .contetn{
    flex: 1;
  }
  .enroll-list ul li .contetn .contetn-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
    padding: 14px 0;
  }
  .enroll-list ul li .contetn .contetn-top .title{
    font-size: 15px;
    color: black;
    font-weight: 600;
  }
  .enroll-list ul li .contetn .contetn-top .type{
    font-size: 10px;
    color: black;
    width: 54px;
    height: 20px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .types{
    background: #e5e5e5 !important;
    color: #676767 !important;
  }
  .enroll-list ul li .contetn .contetn-top .time{
    font-size: 12px;
    color: #999;
    margin-left: 12px;
  }
  .el-button--small {
    padding: 5px 15px;
  }
 
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  .pagination /deep/ .number:hover{
    color: #ff821c !important;
  }
  .enroll-list /deep/ .el-popconfirm__main{
    margin-bottom: 10px;
  }
  .enroll-list /deep/ .el-popconfirm__action span{
    color: #ff821c;
  }
</style>


// WEBPACK FOOTER //
// src/views/enroll/enroll.vue